import {combineReducers} from 'redux'
import LoginReducer from './LoginReducer'
import CoverReducer from './CoverReducer'
import SystemReducer from './SystemReducer'
export default combineReducers({
    LoginReducer:LoginReducer,
    CoverReducer:CoverReducer,
    SystemReducer:SystemReducer
})